import { render } from "./AuthenticatedImage.vue?vue&type=template&id=d0bdd478"
import script from "./AuthenticatedImage.vue?vue&type=script&lang=js"
export * from "./AuthenticatedImage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__